import config from "@/config";
import http from "@/utils/request";

export default {
	list: {
		url: `${config.API_URL}/admin/supplier/list`,
		name: "归属部门列表",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	addAndEdit: {
		url: `${config.API_URL}/admin/supplier/store`,
		name: "新增/编辑归属部门",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	delete: {
		url: `${config.API_URL}/admin/supplier/del`,
		name: "删除归属部门",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
};
